module.exports = __webpack_public_path__ + "img/3.1c91a933.png";